export default "__VITE_ASSET__M6a4pxMb__"